import { FunctionComponent } from "react";
import ConnectedOneLineBet from "../OneLineBet";
import { OneLineBet } from "../OneLineBet/OneLineBet.web";
import { ComponentProps, LotteryAggregatorCardProps } from "./props";

const LotteryAggregatorCard: FunctionComponent<LotteryAggregatorCardProps> = ({
  group,
  hasAvailabilityHints,
  shouldFocusStakeField,
}) => {
  const combinationIds = group.combinations.map(({ id }) => id);

  return (
    <ConnectedOneLineBet
      component={OneLineBet}
      key={group.id}
      id={combinationIds[0]}
      combinationIds={combinationIds}
      shouldFocusStakeField={shouldFocusStakeField}
      hasAvailabilityHints={hasAvailabilityHints}
    />
  );
};

export const LotteriesCard: FunctionComponent<ComponentProps> = ({
  lotteryGroups,
  hasAvailabilityHints,
  shouldFocusStakeField = true,
}) => {
  const { singles, aggregators } = lotteryGroups;

  if (!singles.length && !aggregators.length) {
    return null;
  }

  return (
    <div>
      {singles.map((combination, index) => (
        <ConnectedOneLineBet
          key={combination.id}
          component={OneLineBet}
          id={combination.id}
          shouldFocusStakeField={shouldFocusStakeField && !index}
          hasAvailabilityHints={hasAvailabilityHints}
        />
      ))}
      {aggregators.map((group) => (
        <LotteryAggregatorCard
          key={group.id}
          group={group}
          hasAvailabilityHints={hasAvailabilityHints}
          shouldFocusStakeField={shouldFocusStakeField}
        />
      ))}
    </div>
  );
};
